import { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../services/AuthContext";
import { BootstrapTooltips, DisposeAllTooltips } from "../../services/BootstrapTooltips";
import IconHome from "../SvgIcon/IconHome";
import IconLocation from "../SvgIcon/IconLocation";
import IconLogOut from "../SvgIcon/IconLogOut";
import IconUsers from "../SvgIcon/IconUsers";
import IconMenuOpen from "../SvgIcon/IconMenuOpen";
import IconClose from "../SvgIcon/IconClose";
import IconUserWiseReport from "../SvgIcon/IconUserWiseReport";
import "./style.css";
import IconNotification from "../SvgIcon/IconNotification";
import NotificationRightSide from "./NotificationRightSide";
import TimelineModal from "./TimelineModal";
import api from "../../services";
import socket from "../../services/socket";
import { useSwal } from "../../services/SweetAlert";
import Swal from "sweetalert2";

export default function Header({ pagetitle, icon, secondicon, url, secondiconTitle }) {
  const { setIsLoggedIn } = useAuth();
  const navigate = useNavigate();
  const menuRef = useRef(null);
  const location = useLocation();
  const alert = useSwal();

  const [username, setUsername] = useState("");
  const [userImage, setUserImage] = useState("");
  const [menuVisible, setMenuVisible] = useState(false);

  const [notifications, setNotifications] = useState([]);
  const [notifModalOpen, setNotifModalOpen] = useState(false);
  const [timelineData, setTimelineData] = useState(null);
  const prevIdsRef = useRef(new Set());
  const [hasNewBlink, setHasNewBlink] = useState(false);

  const fetchNotifications = async () => {
    try {
      // console.log("User Id:", localStorage.getItem("userId"));
      const res = await api.post("/getNotificationList", {
        user_id: localStorage.getItem("userId"),
      });
      // console.log("Fetched notifications:", res.data);
      //Mapping will be required
      setNotifications(res.data.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    setUsername(localStorage.getItem("username") || "User");
    setUserImage(localStorage.getItem("userImage") || "");
  }, []);
  // Code for real-time updates via socket

  useEffect(() => {
    socket.emit("joinAdmin");

    const handleNewNotification = async () => {
      console.log("Refreshing notifications...");
      fetchNotifications();
    };
    socket.on("newNotification", handleNewNotification);

    return () => {
      socket.off("newNotification", handleNewNotification);
    };
  }, []);



  useEffect(() => {
    fetchNotifications();
  }, []);

  useEffect(() => { BootstrapTooltips(); }, []);

  // ── Close menu on outside click ───────────────────────────────
  useEffect(() => {
    const handler = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target))
        setMenuVisible(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  useEffect(() => {
    document.body.classList.toggle("menu-open", menuVisible);
    return () => document.body.classList.remove("menu-open");
  }, [menuVisible]);

  const handleLogout = () => {
    DisposeAllTooltips();
    setIsLoggedIn(false);
    localStorage.removeItem("isLoggedIn");
    navigate("/");
  };

  useEffect(() => {
    BootstrapTooltips();
  }, []);

  // ✅ Detect click outside menu
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (menuVisible) {
      document.body.classList.add("menu-open");
    } else {
      document.body.classList.remove("menu-open");
    }

    // cleanup (important)
    return () => {
      document.body.classList.remove("menu-open");
    };
  }, [menuVisible]);

  const handleMarkOneRead = async (id) => {
    setNotifications(prev =>
      prev.map(n =>
        n.id === id
          ? { ...n, is_read: 1 }
          : n
      )
    );

    try {
      const res = await api.post("/markNotificationAsRead", {
        notification_id: id,
      });
      // console.log("markNotificationAsRead", res);
    } catch (err) {
      console.error("Mark read error:", err);

      // rollback
      setNotifications(prev =>
        prev.map(n =>
          n.id === id
            ? { ...n, is_read: 0 }
            : n
        )
      );
    }
  };

  const handleDelete = async (id) => {
    const notif = notifications.find(n => n.id === id);

    // ✅ only confirm if unread (optional logic)
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This notification will be removed.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) return;


    // ✅ instant UI update
    setNotifications(prev =>
      prev.filter(n => n.id !== id)
    );

    try {
      const markNotificationAsDelete = await api.post("/markNotificationAsDelete", {
        notification_id: id,
      });
      // console.log("markNotificationAsDelete", markNotificationAsDelete);
      alert("success", "Notification deleted");
    } catch (err) {
      console.error("Delete error:", err);
    }
  };

  const handleOpenNotif = () => {
    setNotifModalOpen(true);
    setHasNewBlink(false);
  };

  // ✅ is_read from API is 0 (number) — must check === 0, not just falsy
  const unreadCount = notifications.filter(n => n.is_read === 0 || n.is_read === false).length;

  return (
    <header className="d-flex justify-content-between align-items-center">
      <div className="d-flex pagetitle align-items-center">

        <div className="menu-dropdown" ref={menuRef}>
          <button
            className="menu-toggle-btn"
            onClick={() => setMenuVisible(v => !v)}
            data-bs-toggle="tooltip"
            data-bs-placement="bottom"
            title="Menu"
          >
            {menuVisible ? <IconClose /> : <IconMenuOpen />}
          </button>

          <ul className={`menusidebar-dropdown ${menuVisible ? "open" : ""}`}>
            <li><Link to="/dashboard" onClick={() => setMenuVisible(false)}><IconHome />           Dashboard</Link></li>
            <li><Link to="/user-list" onClick={() => setMenuVisible(false)}><IconUsers />          User List</Link></li>
            <li><Link to="/location-list" onClick={() => setMenuVisible(false)}><IconLocation />       Location</Link></li>
            <li><Link to="/leaves" onClick={() => setMenuVisible(false)}><IconUserWiseReport /> Leave Status</Link></li>
          </ul>
        </div>

        {location.pathname !== "/dashboard" && (
          <Link data-bs-toggle="tooltip" data-bs-placement="bottom" title="Dashboard"
            to="/dashboard" className="page-title-icon"><IconHome /></Link>
        )}

        {secondicon && (
          <Link to={url} data-bs-toggle="tooltip" data-bs-placement="bottom"
            title={secondiconTitle} className="page-title-icon">{secondicon}</Link>
        )}

        <span className={`page-title-icon ${location.pathname !== "/dashboard" ? "innericon" : ""}`}>
          {icon}
        </span>
        <h1>{pagetitle}</h1>
      </div>

      <div className="user-logout d-flex align-items-center gap-3">

        {/* <Link to="/user-profile" className="username d-flex align-items-center">
          Welcome,&nbsp;<span className="fw-bold text-capitalize">{username}!</span>
          <span className="userpic ms-3">
            <img src={userImage} alt="user" className="rounded-circle" />
          </span>
        </Link> */}
        <Link to="/user-profile" className="username d-flex align-items-center">
          Welcome,&nbsp;<span className="fw-bold text-capitalize">{username}!</span>
          <span className="userpic ms-3">
            <img src={userImage} alt="user" className="rounded-circle" />
          </span>
        </Link>


        {/* ── Bell button ──────────────────────────────────────── */}
        <button
          className={`notify-icon position-relative ${hasNewBlink ? "notify-blink" : ""}`}
          onClick={handleOpenNotif}
          data-bs-toggle="tooltip"
          data-bs-placement="bottom"
          title="Notifications"
        >
          <IconNotification />
          {/* Badge disappears automatically when unreadCount reaches 0 */}
          {unreadCount > 0 && (
            <span className="notif-badge">
              {unreadCount > 20 ? "20+" : unreadCount}
            </span>
          )}
        </button>

        <button onClick={handleLogout} className="logoutbtn"
          data-bs-toggle="tooltip" data-bs-placement="bottom" title="Logout">
          Logout <IconLogOut />
        </button>
      </div>

      {notifModalOpen && (
        <NotificationRightSide
          notifications={notifications}
          onClose={() => setNotifModalOpen(false)}
          onMarkOneRead={handleMarkOneRead}
          onDelete={handleDelete}
          onOpenTimeline={setTimelineData}
        />
      )}

      {timelineData && (
        <TimelineModal
          data={timelineData}
          onClose={() => setTimelineData(null)}
        />
      )}
    </header>
  );
}